/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { StakingReserveFake } from "./StakingReserveFake";

export class StakingReserveFakeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<StakingReserveFake> {
    return super.deploy(overrides || {}) as Promise<StakingReserveFake>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): StakingReserveFake {
    return super.attach(address) as StakingReserveFake;
  }
  connect(signer: Signer): StakingReserveFakeFactory {
    return super.connect(signer) as StakingReserveFakeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StakingReserveFake {
    return new Contract(address, _abi, signerOrProvider) as StakingReserveFake;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "epoch",
        type: "uint256",
      },
    ],
    name: "FeeInEpoch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "RewardWithdrawn",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimFeesAndVestedReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "depositAndStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "epochRewardHistory",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "perpReward",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    name: "feeMap",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeNotifier",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "feeTokens",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getEpochRewardHistoryLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "getFeeEpochCursor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_epoch",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "getFeeOfEpoch",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "getFeeRevenue",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "balance",
            type: "tuple",
          },
        ],
        internalType: "struct StakingReserve.FeeBalance[]",
        name: "feeBalance",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_epochIndex",
        type: "uint256",
      },
    ],
    name: "getLockedBalance",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "exist",
            type: "bool",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "locked",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "timeWeightedLocked",
            type: "tuple",
          },
        ],
        internalType: "struct StakingReserve.LockedBalance",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "getRewardEpochCursor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalBalance",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_epochIndex",
        type: "uint256",
      },
    ],
    name: "getTotalEffectiveStake",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "getUnlockedBalance",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "getUnstakableBalance",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "getVestedReward",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "reward",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_perpToken",
        type: "address",
      },
      {
        internalType: "contract SupplySchedule",
        name: "_supplySchedule",
        type: "address",
      },
      {
        internalType: "address",
        name: "_feeNotifier",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingPeriod",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
    ],
    name: "isExistedFeeToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mock_getCurrentTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_number",
        type: "uint256",
      },
    ],
    name: "mock_setBlockNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
    ],
    name: "mock_setBlockTimestamp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextEpochIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "notifyRewardAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "notifyTokenAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "perpToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardsDistribution",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_notifier",
        type: "address",
      },
    ],
    name: "setFeeNotifier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rewardsDistribution",
        type: "address",
      },
    ],
    name: "setRewardsDistribution",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_vestingPeriod",
        type: "uint256",
      },
    ],
    name: "setVestingPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stakeBalanceMap",
    outputs: [
      {
        internalType: "bool",
        name: "exist",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "totalBalance",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "rewardEpochCursor",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "feeEpochCursor",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "stakers",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "unstake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vestingPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
